import { Box, Stack, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetMooringsForMap } from 'src/api/moorings'
import { Spinner } from 'src/components/Spinner'
import { IMooring } from 'src/generated-types'
import EmptyMap from 'src/screens/localities/components/map/EmptyMap'
import { MapComponent } from 'src/screens/localities/components/map/MapComponent'

const MapPage = () => {
  const { customerId, localityId } = useParams()
  const theme = useTheme()
  const { data: moorings, isLoading } = useGetMooringsForMap(customerId as EntityId, localityId as EntityId, {
    isWithPositionData: true,
    isIgnoreQueryFilters: sessionStorage.getItem('readModeEnabledLocalityId') == localityId,
  })

  return (
    <Box
      height={window.innerHeight}
      borderRadius={'8px'}
      boxShadow={`0px 2px 8px ${theme.palette.transparentBlack[theme.palette.mode]}`}
      position={'relative'}
    >
      {isLoading ? (
        <Stack
          direction={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'100%'}
          data-test-id="map-loading"
        >
          <Spinner />
        </Stack>
      ) : moorings != undefined && moorings?.length > 0 ? (
        <MapComponent
          navigateLocalityWhenClick={false}
          layerControl={false}
          moorings={moorings as IMooring[]}
          key={'locality-dashboard-map-locality'}
          scrollWheelZoom={false}
          zoom={16.2}
          enableVessel
          enableBoatController
          customerId={customerId}
        />
      ) : (
        <EmptyMap />
      )}
    </Box>
  )
}

export default MapPage
